import React from 'react'
import mixpanel from "mixpanel-browser";

export let mixPanelTrack = async (event_name, event_parameter) => {
    try {
        if (mixpanel.__loaded) {
            mixpanel.track(event_name, event_parameter);
        }
    } catch { }

};